import { CurriculumInterface } from './Curriculum.interface';

export interface LoopInterface {
  id?: number;
  code?: string | LoopCodeEnum;
  label?: string;
  curriculumId?: string;
  curriculum?: CurriculumInterface;
  sequence?: number;
}

export enum LoopCodeEnum {
  INTAKE = 'intake',
  MASTERING = 'mastering',
  REHEARSAL = 'rehearsal',
  STARTING = 'starting',
  INTEGRATION = 'integration',
  DRILLING = 'drilling',
}

export enum LoopStateEnum {
  START = 'start',
  INITIALIZED = 'initialized',
  LOADING = 'loading',
  'LOADING.RESULT' = 'loading result',
  PLAYING = 'playing',
  RESULT = 'result',
  COMPLETED = 'completed',
  ERROR = 'error',
  DISABLED = 'disabled',
}
